<template>
  <div class="moderator-marketing-mailings-history__table-row">
    <div class="moderator-marketing-mailings-history__table-cell  _target">
      <time :datetime="item.created_at | formatDateForTimeTag"
            style="display: block;margin-bottom: 0.8rem; opacity: 0.7">
        {{ item.created_at | formatDate(true) }}
      </time>
      <div class="moderator-marketing-mailings-history__table-cell-title">
        {{ $tModeratorMarketing('Mailing purpose') }}
      </div>
      <div style=" font-weight: 500">{{ item.mailing_target || '-' }}</div>
    </div>
    <div class="moderator-marketing-mailings-history__table-cell  _role">
      <div class="moderator-marketing-mailings-history__table-cell-title">
        {{ $tModeratorMarketing('option_role') }}
      </div>
      <div v-for="(role, index) in item.role"
           :key="index"
           class="moderator-marketing-mailings-history__table-cell-item  d-md-none">
        {{ role }}
      </div>
      <div class="d-none  d-md-block">
        {{ item.role.join('; ') }}
      </div>
      <div v-if="!$get(item.role, 'length')"
           class="moderator-marketing-mailings-history__table-cell-item">
        -
      </div>
    </div>
    <div class="moderator-marketing-mailings-history__table-cell">
      <div class="moderator-marketing-mailings-history__table-cell-title">
        {{ $tModeratorMarketing('option_have_sent') }}
      </div>
      {{ item.have_sent || '-' }}
    </div>
    <div class="moderator-marketing-mailings-history__table-cell">
      <div class="moderator-marketing-mailings-history__table-cell-title">
        {{ $tModeratorMarketing('option_bot_subscribe') }}
      </div>
      {{ item.bot_subscribe || '-' }}
    </div>
    <div class="moderator-marketing-mailings-history__table-cell">
      <div class="moderator-marketing-mailings-history__table-cell-title">
        {{ $tModeratorMarketing('option_have_favorites') }}
      </div>
      {{ item.have_favorites || '-' }}
    </div>
    <div class="moderator-marketing-mailings-history__table-cell">
      <div class="moderator-marketing-mailings-history__table-cell-title">
        {{ $tModeratorMarketing('option_have_primary') }}
      </div>
      {{ item.have_primary || '-' }}
    </div>
    <div class="moderator-marketing-mailings-history__table-cell">
      <div class="moderator-marketing-mailings-history__table-cell-title">
        {{ $tModeratorMarketing('option_age') }}
      </div>
      <div v-for="(age, index) in item.age"
           :key="index"
           class="moderator-marketing-mailings-history__table-cell-item  d-md-none">
        {{ age }}
      </div>
      <div class="d-none  d-md-block">
        {{ item.age.join('; ') }}
      </div>
      <div v-if="!$get(item.age, 'length')"
           class="moderator-marketing-mailings-history__table-cell-item">
        -
      </div>
    </div>
    <div class="moderator-marketing-mailings-history__table-cell">
      <div class="moderator-marketing-mailings-history__table-cell-title">
        {{ $tModeratorMarketing('option_gender') }}
      </div>
      <!--          {{ item.gender.join('; ') }}-->
      <div v-for="(gender, index) in item.gender"
           :key="index"
           class="moderator-marketing-mailings-history__table-cell-item  d-md-none">
        {{ gender }}
      </div>
      <div class="d-none  d-md-block">
        {{ item.gender.join('; ') }}
      </div>
      <div v-if="!$get(item.gender, 'length')"
           class="moderator-marketing-mailings-history__table-cell-item">
        -
      </div>
    </div>
    <div class="moderator-marketing-mailings-history__table-cell">
      <div class="moderator-marketing-mailings-history__table-cell-title">
        {{ $tModeratorMarketing('option_place') }}
      </div>
      <!--          {{ item.place.join('; ') }}-->
      <div v-for="(place, index) in item.place"
           :key="index"
           class="moderator-marketing-mailings-history__table-cell-item  d-md-none">
        {{ place }}
      </div>
      <div class="d-none  d-md-block">
        {{ item.place.join('; ') }}
      </div>
      <div v-if="!$get(item.place, 'length')"
           class="moderator-marketing-mailings-history__table-cell-item">
        -
      </div>
    </div>
    <div class="moderator-marketing-mailings-history__table-cell  _channels">
      <div class="moderator-marketing-mailings-history__table-cell-title">
        {{ $tModeratorMarketing('option_channels') }}
      </div>
      <!--          {{ item.channels.join('; ') }}-->
      <div v-for="(channel, index) in item.channels"
           :key="index"
           class="moderator-marketing-mailings-history__table-cell-item  d-md-none">
        {{ channel }}
      </div>
      <div class="d-none  d-md-block">
        {{ item.channels.join('; ') }}
      </div>
      <div v-if="!$get(item.channels, 'length')"
           class="moderator-marketing-mailings-history__table-cell-item">
        -
      </div>
    </div>
    <div class="moderator-marketing-mailings-history__table-cell  _toggle">
      <button @click.prevent="$emit('toggle')"
              class="moderator-marketing-mailings-history__table-row-toggle">
        <BaseSvg v-if="isOpen"
                 name="ico-minus"
                 width="1rem"
                 height="1rem"/>
        <BaseSvg v-else
                 name="ico-plus"
                 width="1rem"
                 height="1rem"/>
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'AMMarketingMailingsHistoryRow',
    props: {
      item: Object,
      isOpen: Boolean
    },
  }
</script>

<style lang="less">

</style>
